module.exports = __webpack_public_path__ + "static/media/RC_logo_gif-transparent.9802d7b6.gif";